module.exports = __webpack_public_path__ + "img/close.89fef45e.svg";